/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown> }} Coinvestments_Share_Title1Inputs */

const en_coinvestments_share_title1 = /** @type {(inputs: Coinvestments_Share_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share with ${i?.lpName}`)
};

/**
* | output |
* | --- |
* | "Share with {lpName}" |
*
* @param {Coinvestments_Share_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_title1 = /** @type {((inputs: Coinvestments_Share_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_title1(inputs)
});
export { coinvestments_share_title1 as "coInvestments_share_title" }